import React from 'react';

import { getTranslation } from 'helpers/getTranslation';

import { Button } from 'components/shared/Button';

import styles from './Action.module.scss';

const Action = ({
  submitted,
  onRestartLessonClick,
}: {
  submitted: any;
  onRestartLessonClick: any;
}) => {
  return (
    <Button
      className={styles.action}
      disabled={!submitted}
      onClick={onRestartLessonClick}
    >
      {getTranslation('common.button.restart_lesson')}
    </Button>
  );
};

export default React.memo(Action) as any;
